import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20;

import { normalizePhoneNumber } from "@dp/common";
import { computed, observable, runInAction, makeObservable } from "mobx";
import * as yup from "yup";
var phoneRegExp = /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s-]?[\0-9]{3}[\s-]?[0-9]{4}$/;
var alphabetRegExp = /^[a-zA-Z]+$/;

var _SCHEMA = yup.object({
  firstName: yup.string().min(2, "Min. 2 characters required").max(32, "Max. characters allowed are 32").required("This field is mandatory"),
  lastName: yup.string() // .matches(alphabetRegExp, "Only alphabets are allowed for this field")
  .min(2, "Min. 2 characters required").max(32, "Max. characters allowed are 32").required("This field is mandatory"),
  email: yup.string().email("Please enter a valid email").required("This field is mandatory"),
  password: yup.string().required("This field is mandatory"),
  phoneNumber: yup.string().matches(phoneRegExp, "Phone number is not valid").required("This field is mandatory"),
  restaurantZipCode: yup.string().required("This field is mandatory")
});

export var SignUpModel = (_class = /*#__PURE__*/function () {
  function SignUpModel() {
    _classCallCheck(this, SignUpModel);

    _initializerDefineProperty(this, "_firstName", _descriptor, this);

    _initializerDefineProperty(this, "_lastName", _descriptor2, this);

    _initializerDefineProperty(this, "_email", _descriptor3, this);

    _initializerDefineProperty(this, "_password", _descriptor4, this);

    _initializerDefineProperty(this, "_phoneNumber", _descriptor5, this);

    _initializerDefineProperty(this, "_dob", _descriptor6, this);

    _initializerDefineProperty(this, "_subscribeToOffers", _descriptor7, this);

    _initializerDefineProperty(this, "_restaurantName", _descriptor8, this);

    _initializerDefineProperty(this, "_restaurantAddressLineOne", _descriptor9, this);

    _initializerDefineProperty(this, "_restaurantAddressLineTwo", _descriptor10, this);

    _initializerDefineProperty(this, "_restaurantCity", _descriptor11, this);

    _initializerDefineProperty(this, "_restaurantState", _descriptor12, this);

    _initializerDefineProperty(this, "_restaurantZipCode", _descriptor13, this);

    _initializerDefineProperty(this, "_restaurantCountry", _descriptor14, this);

    _initializerDefineProperty(this, "_restaurantId", _descriptor15, this);

    _initializerDefineProperty(this, "_restaurantNum", _descriptor16, this);

    _initializerDefineProperty(this, "_errorsYPosition", _descriptor17, this);

    _initializerDefineProperty(this, "_restaurantLatitude", _descriptor18, this);

    _initializerDefineProperty(this, "_restaurantLongitude", _descriptor19, this);

    _initializerDefineProperty(this, "_socialLinkData", _descriptor20, this);

    makeObservable(this);
  }

  _createClass(SignUpModel, [{
    key: "setErrorsYPosition",
    value: function setErrorsYPosition(key, _errorsYPosition) {
      var _this = this;

      runInAction(function () {
        _this._errorsYPosition[key] = _errorsYPosition;
      });
    }
  }, {
    key: "resetValues",
    value: function resetValues() {
      var _this2 = this;

      runInAction(function () {
        _this2._firstName = "";
        _this2._lastName = "";
        _this2._email = "";
        _this2._password = "";
        _this2._phoneNumber = "";
        _this2._dob = "";
        _this2._subscribeToOffers = true;
        _this2._restaurantName = "";
        _this2._restaurantAddressLineOne = "";
        _this2._restaurantAddressLineTwo = "";
        _this2._restaurantCity = "";
        _this2._restaurantState = "";
        _this2.restaurantZipCode = "";
        _this2._restaurantCountry = "";
        _this2._restaurantId = "";
        _this2._errorsYPosition = {};
        _this2._restaurantLatitude = null;
        _this2._restaurantLongitude = null;
        _this2._socialLinkData = {};
      });
    }
  }, {
    key: "isValid",
    get: function get() {
      return _SCHEMA.isValidSync(this);
    }
  }, {
    key: "errors",
    get: function get() {
      var errObj = {};

      try {
        _SCHEMA.validateSync(this, {
          abortEarly: false
        });
      } catch (e) {
        var error = e;
        error.inner.forEach(function (err) {
          errObj[err.params.path] = err.message;
        });
      }

      return errObj;
    }
  }, {
    key: "firstName",
    get: function get() {
      return this._firstName;
    },
    set: function set(_firstName) {
      var _this3 = this; // if (_firstName && !isAlphaOrContainsSpace(_firstName)) {
      //   return;
      // }


      runInAction(function () {
        _this3._firstName = _firstName;
      });
    }
  }, {
    key: "lastName",
    get: function get() {
      return this._lastName;
    },
    set: function set(_lastName) {
      var _this4 = this;

      runInAction(function () {
        _this4._lastName = _lastName;
      });
    }
  }, {
    key: "email",
    get: function get() {
      return this._email;
    },
    set: function set(_email) {
      var _this5 = this;

      runInAction(function () {
        _this5._email = _email;
      });
    }
  }, {
    key: "password",
    get: function get() {
      return this._password;
    },
    set: function set(_password) {
      var _this6 = this;

      runInAction(function () {
        _this6._password = _password;
      });
    }
  }, {
    key: "phoneNumber",
    get: function get() {
      return this._phoneNumber;
    },
    set: function set(_phoneNumber) {
      var _this7 = this;

      var formattedPhoneNumber = normalizePhoneNumber(_phoneNumber, this._phoneNumber);
      runInAction(function () {
        _this7._phoneNumber = formattedPhoneNumber;
      });
    }
  }, {
    key: "restaurantZipCode",
    get: function get() {
      return this._restaurantZipCode;
    },
    set: function set(_zipCode) {
      var _this8 = this;

      runInAction(function () {
        _this8._restaurantZipCode = _zipCode;
      });
    }
  }, {
    key: "dob",
    get: function get() {
      return this._dob;
    },
    set: function set(_dob) {
      var _this9 = this;

      runInAction(function () {
        _this9._dob = _dob;
      });
    }
  }, {
    key: "restaurantLatitude",
    get: function get() {
      return this._restaurantLatitude;
    },
    set: function set(_restaurantLatitude) {
      var _this10 = this;

      runInAction(function () {
        _this10._restaurantLatitude = _restaurantLatitude;
      });
    }
  }, {
    key: "restaurantLongitude",
    get: function get() {
      return this._restaurantLongitude;
    },
    set: function set(_restaurantLongitude) {
      var _this11 = this;

      runInAction(function () {
        _this11._restaurantLongitude = _restaurantLongitude;
      });
    }
  }, {
    key: "subscribeToOffers",
    get: function get() {
      return this._subscribeToOffers;
    },
    set: function set(_subscribeToOffers) {
      var _this12 = this;

      runInAction(function () {
        _this12._subscribeToOffers = _subscribeToOffers;
      });
    }
  }, {
    key: "errorsYPosition",
    get: function get() {
      return this._errorsYPosition;
    }
  }, {
    key: "restaurantDetails",
    get: function get() {
      return {
        restaurantName: this._restaurantName,
        restaurantAddressLineOne: this._restaurantAddressLineOne,
        restaurantAddressLineTwo: this._restaurantAddressLineTwo,
        restaurantCity: this._restaurantCity,
        restaurantState: this._restaurantState,
        restaurantZipCode: this.restaurantZipCode,
        restaurantCountry: this._restaurantCountry,
        restaurantId: this._restaurantId,
        restaurantNum: this._restaurantNum
      };
    },
    set: function set(restaurantDetails) {
      var _this13 = this;

      var restaurantName = restaurantDetails.restaurantName,
          restaurantAddressLineOne = restaurantDetails.restaurantAddressLineOne,
          _restaurantDetails$re = restaurantDetails.restaurantAddressLineTwo,
          restaurantAddressLineTwo = _restaurantDetails$re === void 0 ? "" : _restaurantDetails$re,
          restaurantCity = restaurantDetails.restaurantCity,
          restaurantState = restaurantDetails.restaurantState,
          restaurantZipCode = restaurantDetails.restaurantZipCode,
          restaurantCountry = restaurantDetails.restaurantCountry,
          restaurantId = restaurantDetails.restaurantId,
          restaurantNum = restaurantDetails.restaurantNum;
      runInAction(function () {
        _this13._restaurantName = restaurantName;
        _this13._restaurantAddressLineOne = restaurantAddressLineOne;
        _this13._restaurantAddressLineTwo = restaurantAddressLineTwo;
        _this13._restaurantCity = restaurantCity;
        _this13._restaurantState = restaurantState;
        _this13.restaurantZipCode = restaurantZipCode;
        _this13._restaurantCountry = restaurantCountry;
        _this13._restaurantId = restaurantId;
        _this13._restaurantNum = restaurantNum;
      });
    }
  }, {
    key: "socialLinkData",
    get: function get() {
      return this._socialLinkData;
    },
    set: function set(_socialLinkData) {
      var _this14 = this;

      runInAction(function () {
        _this14._socialLinkData = _socialLinkData;
      });
    }
  }]);

  return SignUpModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_firstName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_lastName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_email", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_password", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_phoneNumber", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_dob", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_subscribeToOffers", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_restaurantName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_restaurantAddressLineOne", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_restaurantAddressLineTwo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_restaurantCity", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_restaurantState", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_restaurantZipCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_restaurantCountry", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_restaurantId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_restaurantNum", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_errorsYPosition", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_restaurantLatitude", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_restaurantLongitude", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "_socialLinkData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "firstName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lastName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lastName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "email", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "email"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "password", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "password"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "phoneNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantZipCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantZipCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dob", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dob"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantLatitude", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantLatitude"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantLongitude", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantLongitude"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "subscribeToOffers", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "subscribeToOffers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errorsYPosition", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errorsYPosition"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "socialLinkData", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "socialLinkData"), _class.prototype)), _class);